export const canaisDivulgacaoEnum = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  LINKEDIN: 'LINKEDIN',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  OUTROS: 'OUTROS'
};
